import {
  IData,
  IUnits,
  IUnitsData,
  IUnitsTotalData,
} from "../../types/data.types";
import { ICard, DCResearchCards } from "../../types/cards.types";
import { unitTabs } from "../../constants/units";

export const CARDS: ICard<DCResearchCards>[] = [
  {
    key: "dcEstimatedArrivalDate",
    type: "date",
    label: "DC Estimated",
    label2: "Arrival Date",
  },
  {
    key: "dcLastDateReceived",
    type: "date",
    label: "DC Last Date",
    label2: "Received",
  },
  {
    key: "thisWeeksDemand",
    label: "This Weeks",
    label2: "Demand",
  },
  {
    key: "mgrOptionR",
    label: "Mgr.Option",
    label2: "_R_",
  },
  {
    key: "cosmoLimits",
    label: "Cosmo",
    label2: "_Limits_",
  },
  {
    key: "codeDatePickSlot",
    label: "Code Date In",
    label2: "Pick Slot",
  },
];

export const getTotal = (
  row: IData<number>,
  isFar: boolean,
  data?: {
    totalWarehouseData?: IUnitsTotalData;
    totalStoreData?: IUnitsTotalData;
    column: "its" | "doh";
    tab: 0 | 1 | 2;
  }
) => {
  if (
    row.dcInventory === undefined ||
    row.inTransitToDC === undefined ||
    row.onOrder === undefined ||
    row.inTransitToStore === undefined ||
    (isFar && row.storeInventory === undefined)
  ) {
    return undefined;
  }

  const total =
    row.dcInventory +
    row.inTransitToDC +
    row.onOrder +
    row.inTransitToStore +
    (isFar ? row.storeInventory : 0);

  /* istanbul ignore next */
  if (data && data.totalWarehouseData && data.totalStoreData) {
    const key = unitTabs[data.tab].label.replace(" ", "");
    if (data.column === "its") {
      const demand =
        ((data.totalWarehouseData[
          `fourWeekFrwdDemand${key}` as keyof IUnitsTotalData
        ] || 0) +
          (data.totalStoreData[
            `fourWeekFrwdDemand${key}` as keyof IUnitsTotalData
          ] || 0)) /
        2;
      return total / demand;
    } else {
      const demand =
        ((data.totalWarehouseData[
          `eightWeekHstrSeln${key}` as keyof IUnitsTotalData
        ] || 0) +
          (data.totalStoreData[
            `eightWeekHstrSeln${key}` as keyof IUnitsTotalData
          ] || 0)) /
        2;
      return total / demand;
    }
  }
  return total;
};

/* istanbul ignore next */
export const getValues = (
  row: IUnitsData,
  fieldName: keyof IUnits,
  isFar: boolean
) => {
  const response: IData<number> = {};
  if (!row) {
    return response;
  }
  Object.entries(row).forEach(([key, value]) => {
    if (isFar || key !== "storeInventory") {
      if (value && value[fieldName] !== undefined) {
        response[key] = value[fieldName];
      }
    }
  });
  return response;
};
